/**
 * Enum for payment types.
 * @readonly
 * @enum {String} this
 */

const PaymentTypeEnum = {
  CASH              : 'cod',
  isCash            : (paymentMethod) => PaymentTypeEnum.CASH === paymentMethod,
  SELF_DELIVERY     : 'self_delivery',
  isSelfDelivery    : (paymentMethod) => PaymentTypeEnum.SELF_DELIVERY === paymentMethod,
  CARD              : 'pos_card',
  isCard            : (paymentMethod) => PaymentTypeEnum.CARD === paymentMethod,
  POS_IRIS          : 'pos_iris',
  isPosIris         : (paymentMethod) => PaymentTypeEnum.POS_IRIS === paymentMethod,
  QR_IRIS           : 'qr_iris',
  isQrIris          : (paymentMethod) => PaymentTypeEnum.QR_IRIS === paymentMethod,
  ON_CREDIT         : 'on_credit',
  isOnCredit        : (paymentMethod) => PaymentTypeEnum.ON_CREDIT === paymentMethod,
  CHECK             : 'check',
  isCheck           : (paymentMethod) => PaymentTypeEnum.CHECK === paymentMethod,
  WEB_BANKING       : 'web_banking',
  isWebBanking      : (paymentMethod) => PaymentTypeEnum.WEB_BANKING === paymentMethod,
  PREPAID           : 'prepaid',
  isPrepaid         : (paymentMethod) => PaymentTypeEnum.PREPAID === paymentMethod,
  VOUCHER           : 'voucher',
  isVoucher         : (paymentMethod) => PaymentTypeEnum.VOUCHER === paymentMethod,
  TICKET_RESTAURANT : 'ticket_restaurant',
  isTicketRestaurant: (paymentMethod) => PaymentTypeEnum.TICKET_RESTAURANT === paymentMethod,
  MULTIPLE          : 'multiple',
  isMultiple        : (paymentMethod) => PaymentTypeEnum.MULTIPLE === paymentMethod,
  VIVA_SMART        : 'viva_card_smart_checkout',
  isVivaSmart       : (paymentMethod) => PaymentTypeEnum.VIVA_SMART === paymentMethod,
  VIVA_3DS          : 'viva_card_3ds',
  isViva3ds         : (paymentMethod) => PaymentTypeEnum.VIVA_3DS === paymentMethod,
  VIVA_MARKETPLACE  : 'viva_marketplace',
  isVivaMarketplace : (paymentMethod) => PaymentTypeEnum.VIVA_MARKETPLACE === paymentMethod,
  STRIPE            : 'stripe',
  isStripe          : (paymentMethod) => PaymentTypeEnum.STRIPE === paymentMethod,
  EVERYPAY          : 'everypay_card',
  isEverypay        : (paymentMethod) => PaymentTypeEnum.EVERYPAY === paymentMethod,
  DELIVERY          : 'delivery_card',
  isDelivery        : (paymentMethod) => PaymentTypeEnum.DELIVERY === paymentMethod,

  get IRIS() {
    return [PaymentTypeEnum.QR_IRIS, PaymentTypeEnum.POS_IRIS]
  },
  isIris: (paymentMethod) => PaymentTypeEnum.IRIS.includes(paymentMethod),

  get ALL_VOUCHERS() {
    return [PaymentTypeEnum.PREPAID, PaymentTypeEnum.VOUCHER, PaymentTypeEnum.TICKET_RESTAURANT]
  },
  isAnyVoucher: (paymentMethod) => PaymentTypeEnum.IRIS.includes(paymentMethod),

  get ONLINE_CARDS() {
    return [PaymentTypeEnum.VIVA_SMART, PaymentTypeEnum.VIVA_3DS, PaymentTypeEnum.VIVA_MARKETPLACE, PaymentTypeEnum.STRIPE, PaymentTypeEnum.EVERYPAY]
  },
  isOnlineCard: (paymentMethod) => PaymentTypeEnum.ONLINE_CARDS.includes(paymentMethod),

  get DELIVERY_CARDS() {
    return [PaymentTypeEnum.DELIVERY]
  },
  isDeliveryCard: (paymentMethod) => PaymentTypeEnum.DELIVERY_CARDS.includes(paymentMethod),

  get POS_CARDS() {
    return [PaymentTypeEnum.CARD]
  },
  isPosCard: (paymentMethod) => PaymentTypeEnum.POS_CARDS.includes(paymentMethod),

  get EFT_POS_PAYMENT_TYPES() {
    return [...PaymentTypeEnum.POS_CARDS, PaymentTypeEnum.POS_IRIS]
  },
  isEftPosPaymentType: (paymentMethod) => PaymentTypeEnum.EFT_POS_PAYMENT_TYPES.includes(paymentMethod),

  get ALL_CARDS() {
    return [...PaymentTypeEnum.ONLINE_CARDS, ...PaymentTypeEnum.DELIVERY_CARDS, ...PaymentTypeEnum.POS_CARDS]
  },
  isAnyCard: (paymentMethod) => PaymentTypeEnum.ALL_CARDS.includes(paymentMethod),

  get BANK_METHODS() {
    return [PaymentTypeEnum.CHECK, PaymentTypeEnum.QR_IRIS, PaymentTypeEnum.POS_IRIS, PaymentTypeEnum.WEB_BANKING, ...PaymentTypeEnum.ALL_CARDS]
  },
  isBankMethod: (paymentMethod) => PaymentTypeEnum.BANK_METHODS.includes(paymentMethod),

  get ALL_TYPES() {
    return [PaymentTypeEnum.CASH, PaymentTypeEnum.SELF_DELIVERY, ...PaymentTypeEnum.IRIS, PaymentTypeEnum.ON_CREDIT, PaymentTypeEnum.CHECK, PaymentTypeEnum.WEB_BANKING, ...PaymentTypeEnum.ALL_VOUCHERS, PaymentTypeEnum.MULTIPLE, ...PaymentTypeEnum.ALL_CARDS]
  },
  isPaymentMethod: (paymentMethod) => PaymentTypeEnum.ALL_TYPES.includes(paymentMethod),

  get FISCAL_DOCUMENT_METHODS() {
    return [PaymentTypeEnum.ON_CREDIT, ...PaymentTypeEnum.IRIS, PaymentTypeEnum.CHECK, PaymentTypeEnum.WEB_BANKING, ...PaymentTypeEnum.ONLINE_CARDS, ...PaymentTypeEnum.POS_CARDS]
  },
  requiresFiscalDocument: (paymentMethod) => PaymentTypeEnum.FISCAL_DOCUMENT_METHODS.includes(paymentMethod),

  get CLEARED_PAYMENT_METHODS() {
    return [PaymentTypeEnum.ON_CREDIT, PaymentTypeEnum.CHECK, PaymentTypeEnum.WEB_BANKING, PaymentTypeEnum.CASH, PaymentTypeEnum.SELF_DELIVERY, PaymentTypeEnum.QR_IRIS, ...PaymentTypeEnum.DELIVERY_CARDS]
  },
  isMethodWithClearedPayment: (paymentMethod) => PaymentTypeEnum.CLEARED_PAYMENT_METHODS.includes(paymentMethod),

  get DELIVERY_STAFF_ORDER_PAYABLE() {
    return [PaymentTypeEnum.DELIVERY, PaymentTypeEnum.CASH, PaymentTypeEnum.QR_IRIS, PaymentTypeEnum.ON_CREDIT, PaymentTypeEnum.CHECK, PaymentTypeEnum.PREPAID, PaymentTypeEnum.VOUCHER, PaymentTypeEnum.TICKET_RESTAURANT]
  },
  isMethodDeliveryStaffOrderPayable: (paymentMethod) => PaymentTypeEnum.DELIVERY_STAFF_ORDER_PAYABLE.includes(paymentMethod)

}

export default PaymentTypeEnum
